var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-3"},[_c('v-card-text',{staticClass:"d-flex justify-center"},[_c('img',{staticClass:"foto",attrs:{"src":_vm.foto,"alt":"no se encontro"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }